module.exports = __webpack_public_path__ + "img/6t.6c2d7a9b.jpg";